import apiClient from './base/apiClient'

export type PolicyKey = 'terms' | 'privacy' | 'marketing'

export interface Policy {
  key: PolicyKey
  title: string
  content: string // 마크다운
  updated_at?: string
}

export const policyApi = {
  /** 공개: 약관/개인정보/마케팅 내용 조회 (관리자에서 편집한 내용) */
  getPolicy: async (key: PolicyKey): Promise<Policy> => {
    const res = await apiClient.get<Policy>(`/policies/${key}`)
    return res.data
  },
}
